import { render, staticRenderFns } from "./StudentsWithFinishedLiveCourses.vue?vue&type=template&id=de52450c&scoped=true"
import script from "./StudentsWithFinishedLiveCourses.vue?vue&type=script&lang=ts"
export * from "./StudentsWithFinishedLiveCourses.vue?vue&type=script&lang=ts"
import style0 from "./StudentsWithFinishedLiveCourses.vue?vue&type=style&index=0&id=de52450c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de52450c",
  null
  
)

export default component.exports